import { Link } from "react-router-dom";
import type { Episode } from "@/types/content";
import Tag from "@/components/base/Tag";

interface EpisodeCardProps {
  episode: Episode;
}

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/episodes/${episode.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer"
    >
      <div className="relative w-full h-40 overflow-hidden">
        <img
          src={episode.cover}
          alt={`${episode.title} 剧照`}
          title={`${episode.title} - 美国禁忌4 第 ${episode.season} 季第 ${episode.episodeNumber} 集`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 rounded-full bg-background-50/85 backdrop-blur px-2.5 py-1 text-[11px] font-label tracking-wide text-foreground-900">
          第 {episode.season} 季 · 第 {episode.episodeNumber} 集
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-heading text-base text-foreground-950 group-hover:text-accent-400 transition-colors">
          {episode.title}
        </h3>
        <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed line-clamp-3 flex-1">{episode.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between gap-2">
          <Tag tone="secondary">
            <i className="ri-calendar-line mr-1" />
            {episode.airDate}
          </Tag>
          <span className="flex items-center gap-3 text-xs text-foreground-500 font-label">
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {episode.runtime}
            </span>
            <span className="flex items-center gap-1 text-accent-400">
              <i className="ri-star-fill" />
              {episode.rating}
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}